import { render, staticRenderFns } from "./StatusReview.vue?vue&type=template&id=0efaa61d"
import script from "./StatusReview.vue?vue&type=script&lang=js"
export * from "./StatusReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports